<template>
  <div>
    <Headers />
    <div>
      <div class="min-h-screen bg-white py-8 px-4 sm:px-6 lg:px-8">
        <div class="max-w-7xl mx-auto">
          <!-- 标题 -->
          <h1 class="text-3xl font-bold text-gray-900 mb-12">PRODUCTS</h1>

          <!-- 产品网格 -->
          <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <!-- 产品卡片 -->
            <div
              v-for="product in products"
              :key="product.id"
              class="group cursor-pointer"
              @click="jump('/product-detail')"
            >
              <!-- 产品图片容器 -->
              <div class="relative w-full h-48 mb-4 overflow-hidden rounded-lg">
                <img
                  :src="product.image"
                  :alt="product.name"
                  class="product-image w-full h-40 object-contain"
                />
              </div>

              <!-- 产品信息 -->
              <div class="text-center">
                <h3 class="text-sm font-medium text-gray-700 uppercase mb-2">
                  {{ product.name }}
                </h3>
                <p class="text-sm text-gray-900">
                  <span v-if="product.pricePrefix"
                    >{{ product.pricePrefix }}
                  </span>
                  <!-- <span class="font-medium">${{ product.price }}</span> -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script lang="js">
import Headers from '@/components/Headers.vue';
import Footer from '@/components/Footer.vue';
import {productList} from "../data/data"
export default {
  name: "ProductsPage",
  components: {
    Headers,
    Footer
  },
  data() {
    return {
      products: productList,
    };
  },
  methods: {
    jump(path) {
      this.$router.push(path);
    },
  }
};
</script>

<style scoped>
.product-image {
  transition: transform 0.3s ease-in-out;
}

.product-image:hover {
  transform: scale(1.1);
}
</style>
